import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";


export const PrimaryText = styled(Text)`
  color: #040222;
`;

export const SecondaryText = styled(Text)`
  color: #5b5675;
  font-weight: 500;
`;


export const Container = styled(Flex)`
  flex-direction: row;
  align-items: center;
`;

export const TextContainer = styled(Flex)`
  margin-left: 0.75rem;
  flex-direction: column;
  gap: 4px;
`;

export const AddCta = styled(Text)`
  color: #1b73e8;
  cursor: pointer;
  align-self: flex-start;
  justify-self: flex-end;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
export const RemoveCta = styled(Text)`
  color: #d83d37;
  cursor: pointer;
  align-self: flex-start;
  justify-self: flex-end;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const CouponApppliedText = styled(Text)`
  color: #0b753e;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;
